<template>
    <basic-container>
        <avue-form :defaults.sync="defaultFrom"  :option="searchFromOption" v-model="searchForm">
            <template slot="communityId">
                <!-- <el-select 
                    v-model="searchForm.communityId"
                    @change="communityIdChange"
                >
                    <el-option
                        v-for="item in communityList"
                        :key="item"
                        :value="item.id"
                        :label="item.title"
                    >
                    </el-option>
                </el-select> -->
                <avue-input-tree 
                    node-key="id"
                    :props="defaultProps"
                    default-expand-all 
                    v-model="searchForm.communityId" 
                    placeholder="请选择小区" 
                    type="select" 
                    @change="communityIdChange"
                    :dic="communityList"
                >
                </avue-input-tree>
            </template>
            <template slot="buildingId">
                <!-- <el-select 
                    v-model="searchForm.buildingId"
                    @change="buildingIdChange"
                >
                    <el-option
                        v-for="item in buildingList"
                        :key="item"
                        :value="item.value"
                        :label="item.label"
                    >
                    </el-option>
                </el-select> -->
                
                <avue-input-tree 
                    node-key="value"
                    :props="defaultPropsBuilding"
                    default-expand-all 
                    v-model="searchForm.buildingId" 
                    placeholder="请选择楼栋/单元" 
                    type="select" 
                    @change="buildingIdChange"
                    :dic="buildingList"
                >
                </avue-input-tree>
            </template>
            <template slot="targetId">
                <!-- <el-select 
                    v-model="searchForm.targetId"
                    @change="targetIdChange"
                >
                    <el-option
                        v-for="item in targetList"
                        :key="item"
                        :value="item.value"
                        :label="item.label"
                    >
                    </el-option>
                </el-select> -->

                
                <avue-input-tree 
                    node-key="value"
                    :props="defaultPropsRoom"
                    default-expand-all 
                    v-model="searchForm.targetId" 
                    placeholder="请选择房号" 
                    type="select" 
                    @change="targetIdChange"
                    :dic="targetList"
                >
                </avue-input-tree>
            </template>
        </avue-form>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="收费" name="first" style="overflow:scroll;height: 600px;">
                <FeeContainer ref="feeContainer" :targetId.sync="searchForm.targetId"/>
            </el-tab-pane>
            <el-tab-pane label="临时收费" name="second" style="overflow:scroll;height: 600px;">
                <TempFeeContainer ref="tempFeeContainer" :targetId.sync="searchForm.targetId"/>
            </el-tab-pane>
            <el-tab-pane label="客户信息" name="third" style="overflow:scroll;height: 600px;">
                <ClientContainer />
            </el-tab-pane>
            <el-tab-pane label="账单查询" name="four" style="overflow:scroll;height: 600px;">
                <FeeSearch ref="feeSearch" :searchItem="searchForm" ></FeeSearch>
            </el-tab-pane>
            <el-tab-pane label="收费历史" name="five" style="overflow:scroll;height: 600px;">
                <FeeHistory ref="feeHistory" :searchItem="searchForm"></FeeHistory>
            </el-tab-pane>
            <el-tab-pane label="基础信息" :name="six" style="overflow:scroll;height: 600px;">
                <FeeBaseInfo ref="feeBaseInfo" :householderRoomInfo="householderRoomInfo" ></FeeBaseInfo>
            </el-tab-pane>
            <el-tab-pane label="优惠政策" :name="seven" style="overflow:scroll;height: 600px;">
                <FeeFavouredPolicy ref="feeFavouredPolicy"  ></FeeFavouredPolicy>
            </el-tab-pane>
        </el-tabs>
    </basic-container>
</template>

<script>
import FeeContainer from "./tab-container/fee";
import TempFeeContainer from "./tab-container/temp-fee";
import ClientContainer from "./tab-container/client";
import FeeSearch from "./tab-container/fee-search";
import FeeHistory from "./tab-container/fee-history";
import FeeBaseInfo from "./tab-container/fee-baseinfo";
import FeeFavouredPolicy from "./tab-container/fee-favouredPolicy";
import {
    getNode,
    loadRoomTree1,
    loadRoomTree2,
    loadCommunityList,
    loadBuildingList,
    loadRoomList,
    loadZhxx,
    getArrears,
    getCouponList,
    getSubjectList,
    getHouseholderRoomInfo,
    
} from '@/api/charge/charge-pay';
export default {
    components: { FeeContainer,TempFeeContainer,ClientContainer ,FeeSearch,FeeHistory,FeeBaseInfo,FeeFavouredPolicy},
    data() {
      return {
        defaultProps:{
            children: 'children',
            label: 'title'
        },
        defaultPropsBuilding:{
            children: 'children',
            label: 'label'
        },
        defaultPropsRoom:{
            children: 'children',
            label: 'label'
        },
        searchForm:{},
        communityList:[],
        buildingList:[],
        targetList:[],
        activeName: 'first',
        subjectList:[],
        //主查询必须验证通过才能进行辅助查询
        // masterValidateStatus:{
        //     type:boolean,
        // }
        householderRoomInfo:{},//户主房屋信息
        householderInfo:[],//户主信息
        defaultFrom:{}
      };
    },
    computed: {
       searchFromOption(){
         return{
            menuBtn:false,
            column: [{
                        label: "小区名称",
                        prop: "communityId",
                        type: "select",
                        formslot:true,
                        span: 6,
                        maxlength: 3,
                        rules: [{
                            required: true,
                            message: "请选择小区名",
                            trigger: "change"
                        }],
                    },{
                        label: "楼栋/单元",
                        prop: "buildingId",
                        type: "select",
                        formslot:true,
                        span: 6,
                        maxlength: 3,
                        rules: [{
                            required: true,
                            message: "请选择楼栋/单元名",
                            trigger: "change"
                        }],
                    },{
                        label: "房号",
                        prop: "targetId",
                        type: "select",
                        formslot:true,
                        span: 6,
                        maxlength: 3,
                        rules: [{
                            required: true,
                            message: "请选择房号",
                            trigger: "change"
                        }],
                    },{
                        label: "户主",
                        prop: "householderName",
                        span: 6,
                        maxlength: 3,
                        disabled:true,
                        rules: [{
                            required: true,
                            message: "请输入用户名",
                            trigger: "blur"
                        }],
                    },{
                        label: "欠缴总额",
                        prop: "arrears",
                        disabled:true,
                        span: 6,
                        maxlength: 3,
                        rules: [{
                            required: true,
                            message: "请输入用户名",
                            trigger: "blur"
                        }],
                    }]
            }



        }
    },
    created(){
        loadRoomTree1().then(({ data }) => {
            this.communityList = data;
            if(data.length>0){
                this.searchForm.communityId = data[0].id
            }
            console.log(data);
        });
        this.getSubjectListHandlerAction();
    },
    methods: {
        getSubjectListHandlerAction(){
            getSubjectList().then((res)=>{
                console.log(res);
                this.subjectList = res.data;
            })
        },
        handleClick(tab, event) {
            console.log(tab, event);
        },
        communityIdChange(val){

            this.$refs.feeContainer.subjectDisabled();
            this.$refs.feeSearch.subjectDisabled();
            this.$refs.feeHistory.subjectDisabled();
            loadBuildingList({ propertyId: val }).then(({ data }) => {
                console.log(data);
                this.buildingList = data;
                this.targetList = [];
                this.searchForm.buildingId = '';
                this.searchForm.targetId = '';
            });
      },
      buildingIdChange(val){
        this.$refs.feeContainer.subjectDisabled();
        this.$refs.feeSearch.subjectDisabled();
        this.$refs.feeHistory.subjectDisabled();
        loadRoomList({ propertyId: val }).then(({ data }) => {
            console.log(data);
            this.targetList = data;
            this.searchForm.targetId = '';
        });
      },
      targetIdChange(val){
        //   没选择房号
          if(!val){
              // 小区搜索结果为空，表格数据清空
            this.searchForm.householderName = ""
            this.searchForm.arrears = ""
            this.$refs.feeHistory.restTable();
            this.$refs.feeFavouredPolicy.restTable();
            this.$refs.feeBaseInfo.restTable();
            this.$refs.feeSearch.restTable();
            this.householderRoomInfo = {}
            //搜索按钮禁用
            this.$refs.feeContainer.subjectDisabled();
            this.$refs.feeSearch.subjectDisabled();
            this.$refs.feeHistory.subjectDisabled();
          }
          if(!val){
              return;
          }
          let targetName = '';
          this.targetList.forEach((ele,index)=>{
              if(ele.value === val){
                targetName = ele.label;
              }
          });
          this.$refs.feeContainer.getSubjectListHandler(val);
          this.$refs.feeContainer.subjectActive();
          this.$refs.feeSearch.subjectActive();
          this.$refs.feeSearch.search();
          this.$refs.feeHistory.subjectActive();
          this.$refs.feeHistory.search();
          this.$refs.feeFavouredPolicy.search(this.searchForm.communityId)
          loadZhxx({roomId:val}).then(({ data }) => {
                this.searchForm.householderName = data[0].householder;
                this.$refs.tempFeeContainer.getSubjectListHandler(val,targetName,this.searchForm.householderName);
            });
            getArrears({targetId:val}).then(({ data }) => {
                this.searchForm.arrears = data;
            });
            //获取户主房屋信息
            getHouseholderRoomInfo({id:val}).then(({data})=> {
                this.householderRoomInfo = data
                for(let key in this.householderRoomInfo){
                    this.householderRoomInfo[key]=(this.householderRoomInfo[key]== "null"? ' ':this.householderRoomInfo[key])
                } 
            });
            //获取户主房屋信息
            this.$refs.feeBaseInfo.search(val)
            
            // this.subjectList.forEach((ele,index)=>{
            //     getCouponList({
            //         subjectId:ele.id,
            //         targetId:val,
            //         resourceType:'1'
            //     }).then(({data})=>{
            //         console.log("getCouponList=====>",data);
            //     });
            // });
       
          this.$refs.feeContainer.loadBillList(val,targetName);
      },
    }
}
</script>

<style>

</style>